import React, { createContext, useState, useEffect, useContext } from "react";
import api from "../../services/api";
import useWhatsApps from "../../hooks/useWhatsApps";
import WavoipPhoneWidget from "../../components/WavoipCall";
import { AuthContext } from "../Auth/AuthContext";

const WhatsAppsContext = createContext();

const WhatsAppsProvider = ({ children }) => {
  const whatsAppData = useWhatsApps();
  const { loading = false, whatsApps = [], error = null, reload } = whatsAppData || {};
  const { user, isAuth, loading: authLoading } = useContext(AuthContext);
  
  const [wavoipToken, setWavoipToken] = useState(null);

  const userId = user?.id;
  const companyId = user?.companyId;
  useEffect(() => {
    let active = true;
    setWavoipToken(null);
    if (authLoading || !isAuth || !userId || !companyId) return () => { active = false; };
    const fetchSession = async () => {
      try {
        const { data } = await api.get("/call/historical/user/whatsapp");

        if (active) setWavoipToken(data?.whatsapp?.wavoip || null);
      } catch (err) {
        if (active) setWavoipToken(null);
      }
    };
    fetchSession();
    return () => { active = false; };
  }, [authLoading, isAuth, userId, companyId]);

  return (
    <WhatsAppsContext.Provider value={{ whatsApps, loading, error, reload }}>
      {children}
      {wavoipToken && (
        <WavoipPhoneWidget
          token={wavoipToken}
          position="bottom-right"
          name={user?.company?.name || "waVoip"}
          country="BR"
          autoConnect={true}
          onCallStarted={(data) => console.log("Chamada iniciada:", data)}
          onCallEnded={(data) => console.log("Chamada finalizada:", data)}
          onConnectionStatus={(status) => console.log("Status:", status)}
          onError={(error) => console.error("Erro:", error)}
        />
      )}
    </WhatsAppsContext.Provider>
  );
};

export { WhatsAppsContext, WhatsAppsProvider };